import { Grid, Typography } from '@mui/material';
import { formatEpochDate } from '@tassat/utility';
import moment from 'moment';
import React from 'react';

import OverviewStatsTable from './overviewStatsTable';
import { muiStyles } from './styles';
import ApiOpsTransactionStatistics from './transactionStatistics';

const ApiOpsDashboard: React.FC<object> = (props) => {
    const classes = muiStyles(props);

    return (
        <Grid
            className={classes.root}
            container
            direction='column'
            wrap='nowrap'
        >
            <Grid
                className={classes.sectionContainer}
                item
            >
                <Typography
                    className={classes.headerText}
                    variant='h3'
                >
                    <strong>API Ops Dashboard </strong>
                    {formatEpochDate(moment()
                        .valueOf(), 'MMMM DD, YYYY')}
                </Typography>
            </Grid>
            <Grid
                className={classes.sectionContainer}
                container
                item
            >
                <OverviewStatsTable />
            </Grid>
            <Grid
                className={classes.sectionContainer}
                container
                item
            >
                <ApiOpsTransactionStatistics />
            </Grid>
        </Grid>
    );
};

export default ApiOpsDashboard;